<template>
    <div 
     id="stream">
      <GridItemContainer 
        v-for="(project, index) in postArray" :key="project.id"
        v-bind:project.sync="project"
        v-bind:index="index"
      />
    </div>
</template>

<script>
	import GridItemContainer from './grid-item-container';
	import {assignRow} from '../functions/image-grid.js';


  export default {
    name: 'App',
    components: {
      GridItemContainer
    },
    props: {
      postArray: Array,
    },
    methods:{
      echoData: function( ){
        assignRow( this.postArray , 2 ) // 2nd para == first row image length
      }
    },
    watch: {
      postArray: {
        immediate: true,
        deep: true,
        handler(newValue, oldValue) {
          this.echoData()
        }
      }
    },
  }
</script>


<style type="text/css" lang="scss">
  #stream{
  position: relative;
	width: calc(100% + #{$outlineOffset} * 2); // outline-offset correction
	margin-left: calc(-1 * #{$outlineOffset});
  display: flex;
  flex-wrap: wrap;
  overflow: hidden;

  perspective: 100vw;
  transform-style: preserve-3d;
  backface-visibility: hidden;
  padding-top: $headerMargin;
  padding-bottom: $headerMargin;

@media( $max640 ){
		margin-top: 0;
	}
  }
</style>